import * as yup from 'yup';
import { MAX_FILE_SIZE } from './constants';

export const validationSchema = yup.object().shape({
    description: yup.string().required('Description is required'),
    attachments: yup.array().of(
        yup.object().shape({
            file: yup
                .mixed()
                .test('is-valid-size', 'Max allowed size is 5MB', (value) =>
                    value ? (value as { size: number }).size <= MAX_FILE_SIZE : true,
                ),
        }),
    ),
});
